/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Exercise_UnknownInputs */

const en_us2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the exercises is not in the catalogue anymore. Review the matches and try again.`)
};

const pt_br2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um dos exercícios não está mais no catálogo. Revise as correspondências e tente de novo.`)
};

const es_419_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno de los ejercicios ya no está en el catálogo. Revisa las correspondencias e inténtalo de nuevo.`)
};

const pt_pt2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um dos exercícios já não está no catálogo. Revê as correspondências e tenta outra vez.`)
};

const fr_fr2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un des exercices n'est plus dans le catalogue. Vérifie les correspondances et réessaie.`)
};

const de_de2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine der Übungen ist nicht mehr im Katalog. Prüf die Zuordnungen und versuch es noch mal.`)
};

const it_it2_import_exercise_unknown = /** @type {(inputs: Import_Exercise_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno degli esercizi non è più nel catalogo. Rivedi le corrispondenze e riprova.`)
};

/**
* | output |
* | --- |
* | "One of the exercises is not in the catalogue anymore. Review the matches and try again." |
*
* @param {Import_Exercise_UnknownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const import_exercise_unknown = /** @type {((inputs?: Import_Exercise_UnknownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Exercise_UnknownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_import_exercise_unknown(inputs)
	if (locale === "es-419") return es_419_import_exercise_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_import_exercise_unknown(inputs)
	if (locale === "fr-FR") return fr_fr2_import_exercise_unknown(inputs)
	if (locale === "de-DE") return de_de2_import_exercise_unknown(inputs)
	if (locale === "it-IT") return it_it2_import_exercise_unknown(inputs)
	return en_us2_import_exercise_unknown(inputs)
});
export { import_exercise_unknown as "import.exercise_unknown" }